import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import PlayArrowIcon from "@material-ui/icons/PlayArrow";
import SkipNextIcon from "@material-ui/icons/SkipNext";

import fontConfig from "../../constants/fonts";
import { Button, Divider, Grid, Hidden } from "@material-ui/core";
import { getImageUrl } from "../../redux/types";
// import fontConfig from "../../constants/fonts";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    height: 400,
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    borderRadius: 20,
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "100%",
    },
  },
  card: {
    width: "80%",
    height: "80%",
    // display: "flex",
    borderRadius: 20,
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "100%",
    },
  },
  cover: {
    width: "100%",

    borderRadius: 20,
    border: "1px solid #D0D0D0",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      height: "100%",
    },
  },
  controls: {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  playIcon: {
    height: 38,
    width: 38,
  },
  titleContainer: {},
  // title: {
  //   ...fontConfig.semibold,
  //   fontSize: "2rem",
  //   color: "white",
  //   backgroundColor: theme.palette.primary.main,
  //   // width: "20%",
  //   width: "15%",
  //   textAlign: "center",
  //   padding: 10,
  // },
  personalityContainer: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(1),
    },
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  cardInfoContainer: {
    marginTop: theme.spacing(1),
    width: "100%",
  },
  // name: {
  //   ...fontConfig.medium,
  //   fontSize: "1rem",
  //   color: theme.palette.primary.main,
  // },
  occupation: {
    ...fontConfig.regular,
    fontSize: "1rem",
    fontWeight: "600",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
    },
  },
  abhipray: {
    ...fontConfig.regular,
    fontSize: "0.8rem",
    fontWeight: "500",
    [theme.breakpoints.down("md")]: {
      fontSize: "0.8rem",
    },
  },
  name: {
    ...fontConfig.bold,
    fontSize: "1.5rem",
    color: theme.palette.primary.main,
    // fontFamily: ,
    textTransform: "uppercase",
    // letterSpacing: "0.1rem",
    // backgroundColor: theme.palette.primary.main,
    borderRadius: 100,
    // boxShadow: "5px 5px 20px rgba(0,0,0,0.2)",
    // width: "20%",
    // width: "15%",

    [theme.breakpoints.down("md")]: {
      fontSize: "1rem",
      letterSpacing: "0.05rem",
    },
  },
  Divider: {
    width: "100%",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  btn: {
    borderRadius: 100,
  },
  content: {
    height: 250,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    // backgroundColor: "red",
    width: "100%",
    [theme.breakpoints.down("md")]: {
      height: "170px",
    },
  },
  btnContainer: {
    // backgroundColor: "green",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
}));

const PortFolioItem = ({ data }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Card className={classes.card} elevation={0}>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item direction="column" lg={3} md={3} sm={4} xs={4}>
              <img
                className={classes.cover}
                src={getImageUrl(data.image)}
                alt="Live from space album cover"
              />
            </Grid>
            <Grid item lg={9} md={8} sm={8} xs={8}>
              <Typography variant="body1" className={classes.name}>
                {data.name}
              </Typography>
              <Divider className={classes.Divider} />
              <Typography
                variant="subtitle1"
                color="textPrimary"
                className={classes.occupation}
              >
                {data.occupation}
              </Typography>
              <Hidden mdDown>
                <Typography
                  variant="subtitle1"
                  color="textSecondary"
                  className={classes.abhipray}
                >
                  {data.description}
                </Typography>
              </Hidden>
            </Grid>
            <Hidden smUp>
              <Grid item sm={12} xs={12}>
                <Divider className={classes.Divider} />

                <Typography
                  variant="body"
                  color="textSecondary"
                  className={classes.abhipray}
                >
                  {data.description}
                </Typography>
              </Grid>
            </Hidden>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
};
export default PortFolioItem;
